import React, { useEffect, useRef } from 'react';
import Form from '@rjsf/daisyui';
import validator from '@rjsf/validator-ajv8';

const JsonSchemaForm = ({
  schema,
  formData,
  uiSchema,
  onSubmit,
  onChange,
  onError,
  className = '',
  ...props
}) => {
  const formRef = useRef(null);

  useEffect(() => {
    return () => { };
  }, []);

  const handleSubmit = (event) => {
    // Prevent default form submission behavior
    if (onSubmit) {
      onSubmit(event);
    }
  };

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }
  };

  const handleError = (errors) => {
    if (onError) {
      onError(errors);
    }
  };

  return (
    <div className={`json-schema-form ${className}`} ref={formRef}>
      <Form
        schema={schema}
        formData={formData}
        uiSchema={uiSchema}
        validator={validator}
        onSubmit={handleSubmit}
        onChange={handleChange}
        onError={handleError}
        noValidate={false}
        {...props}
      />
    </div>
  );
};

export default JsonSchemaForm;
